export default __webpack_public_path__ + "static/media/folder-cover.3e29a868.png";